import React from 'react'

type Props = {
  className?: string
}

const Lightning: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="24" height="24" rx="4" fill="#FAF0D1" />
    <path
      d="M9.33341 18.6668L10.0001 14.0002H6.66675L12.6667 5.3335H14.0001L13.3334 10.6668H17.3334L10.6667 18.6668H9.33341Z"
      fill="#E7B41A"
    />
  </svg>
)

export default Lightning
